var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RadarChart',{ref:"chart",staticClass:"pivots-chart",class:{ 'pivots-chart--small-device': _vm.isSmallDevice },attrs:{"params":_vm.radarChartParams}})
}
var staticRenderFns = []

export { render, staticRenderFns }